/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicOperationAssessment extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicOperationAssessment");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicOperationAssessment.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicOperationAssessment>): BackgroundJobPayloadForPeriodicOperationAssessment {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicOperationAssessment(), model);
        BackgroundJobPayloadForPeriodicOperationAssessment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicOperationAssessment>): BackgroundJobPayloadForPeriodicOperationAssessment {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicOperationAssessment.newInstance(<BackgroundJobPayloadForPeriodicOperationAssessment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicOperationAssessment) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicOperationAssessment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicOperationAssessment): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicOperationAssessment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
